module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_sorvete.ffaf4b00.png";